import React from 'react';
import { useNavigate } from 'react-router-dom';

interface NotFoundProps {
  message?: string;
  showHomeButton?: boolean;
  layout?: 'public' | 'auth' | 'protected';
}

export const NotFound: React.FC<NotFoundProps> = ({ 
  message = "The page you're looking for doesn't exist.",
  showHomeButton = true,
  layout = 'public'
}) => {
  const navigate = useNavigate();

  const getHomeRoute = () => {
    switch (layout) {
      case 'auth':
        return '/auth/login';
      case 'protected':
        return '/dashboard';
      default:
        return '/';
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-indigo-100">
      <div className="text-center px-6">
        <div className="mb-8">
          <span className="text-9xl font-bold text-indigo-600">404</span>
        </div>
        <h1 className="text-3xl font-bold text-gray-800 mb-4">
          Page Not Found
        </h1>
        <p className="text-gray-600 mb-8 max-w-md mx-auto">
          {message}
        </p>
        <div className="space-x-4">
          <button
            onClick={() => navigate(-1)}
            className="px-6 py-3 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 transition"
          >
            Go Back
          </button>
          {showHomeButton && (
            <button
              onClick={() => navigate(getHomeRoute())}
              className="px-6 py-3 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 transition"
            >
              Go Home
            </button>
          )}
        </div>
      </div>
    </div>
  );
};